import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function ArticlesPage() {
  return (
    <>
      <SEOHead
        title="文章中心 - 上网指南与网站推荐 | 九色导航"
        description="九色导航文章中心为您提供上网技巧、浏览器设置指南、优质网站推荐、网络安全防护等实用内容，助您成为高效上网达人。"
        keywords="上网指南,浏览器设置,网站推荐,上网技巧,网络安全,导航使用教程,九色导航"
        canonicalUrl="/articles"
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <header className="pt-24 pb-8 px-4 md:px-6 bg-background-100/50">
          <div className="max-w-screen-2xl mx-auto">
            <div className="mb-4">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '文章中心' },
                ]}
              />
            </div>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950">
              文章中心
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              上网指南、网站推荐、使用教程，助您成为高效上网达人
            </p>
          </div>
        </header>

        <main className="py-10 px-4 md:px-6">
          <div className="max-w-screen-2xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>

            {articles.length === 0 && (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 rounded-2xl bg-background-100 flex items-center justify-center">
                  <i className="ri-article-line text-3xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">暂无文章，敬请期待</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}